import { useCallback, useContext } from "react"
import {
  BitcoinCircle,
  Block,
  Button,
  ButtonProps,
  EthCircle,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { FlowContext } from "#/shared/context"
import { usePosthogOnboardingEvent } from "#/shared/hooks"
import { AnalyticsId, Flow } from "#/shared/types"

type OnboardingModalFlowButtonProps = Omit<
  ButtonProps,
  "children" | "onClick"
> & {
  onClick: () => void
  flow: Flow
}

export default function OnboardingModalFlowButton({
  flow,
  onClick,
  ...props
}: OnboardingModalFlowButtonProps) {
  const { emitOnboardingButtonClickedEvent } = usePosthogOnboardingEvent()
  const { setFlow } = useContext(FlowContext)
  const [css, theme] = useStyletron()

  const buttonHandler = useCallback(() => {
    setFlow(flow)
    onClick()

    emitOnboardingButtonClickedEvent(
      flow === Flow.BITCOIN
        ? AnalyticsId.BITCOIN_WALLET
        : AnalyticsId.ETHEREUM_WALLET,
    )
  }, [flow, onClick, setFlow, emitOnboardingButtonClickedEvent])

  return (
    <Button
      onClick={buttonHandler}
      kind="secondary"
      width="100%"
      startEnhancer={
        <Block
          className={css({
            height: theme.sizing.scale800,
            width: theme.sizing.scale800,
            backgroundColor: theme.colors.black,
            borderRadius: theme.borders.radius200,
            overflow: "hidden",
            display: "grid",
            placeItems: "center",
          })}
        >
          {flow === Flow.BITCOIN ? (
            <BitcoinCircle size={24} color={theme.colors.black} />
          ) : (
            <EthCircle size={24} color={theme.colors.black} />
          )}
        </Block>
      }
      {...props}
    >
      Continue with {flow[0].toUpperCase()}
      {flow.slice(1)}
    </Button>
  )
}
